import services from '@/http'
import * as types from './mutation-types'

export const ActionGetFinishOrder = (context,payload) => (
  services.acompanhar_pedido.getFinishOrder({id:payload}).then(res => {
    context.commit(types.FINISH_ORDERS, res.data.results)
  })
  .catch(err => {
    err
    alert('Erro ao buscar pedidos.')
    return 'ERROR'
  })
)